import api from '../../api';

export default function editOffer(brandId,offerId,data) {
  return api.patch(`/brands/manage/${brandId}/offers/${offerId}`,data);
}